import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main_zc" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "资产名称：", -1)
const _hoisted_7 = {
  class: "header_twonr",
  style: {"margin-top":"20px"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("导出报表")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_17 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_18 = { class: "my-header" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, "添加编辑资产", -1)
const _hoisted_20 = { class: "my-header" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, "导出报表", -1)
const _hoisted_22 = { class: "dc_dialog flexWrap" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { style: {"color":"#646464"} }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"26%","margin-bottom":"20px"} }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"26%","margin-bottom":"20px"} }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1)
const _hoisted_28 = {
  slot: "footer",
  class: "flexCenter"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("提 交")
const _hoisted_31 = ["href"]

import { CirclePlus,Search,Download } from '@element-plus/icons-vue';
    import { ref,onMounted,computed,nextTick } from 'vue';
    import {
        requestZcglList,
		requestZcglDel,
		requestDc,requestZcSubjssj,requestZcSubjssj1
    } from '@/api/zcApi.js';
	import { 
		apiName,
		requestMyuser
	} from '@/api/api.js'
    import AddZc from '@/components/Zc/AddZc.vue';
	import { ElMessage } from 'element-plus';
	
export default /*#__PURE__*/_defineComponent({
  name: 'ZcList',
  setup(__props) {

	const api = ref(apiName)
	const dcLink = ref('')
	const dcRef = ref()//导出
    const show = ref(false)
    const tableData = ref<any[]>([])
	const loading = ref<boolean>(false)
    const pageIndex = ref<number>(1)
	const pageSize = ref<number>(10)
	const pages = ref({
		totalCount:0
	})
	const search = ref({
		name:''
	})
	const id = ref(0)
	const dcShow = ref(false)
	const userList = ref<any>({})
	const dcList = ref<any[]>([
        {name:'序号',open:false,value:'xhid'},
        {name:'资产名称',open:false,value:'name'},
        {name:'资产编号',open:false,value:'bh'},
        {name:'资产类型',open:false,value:'lx'},
        {name:'序列号',open:false,value:'xlh'},
        {name:'节点品牌',open:false,value:'jdpp'},
        {name:'节点型号',open:false,value:'jdxh'},
        {name:'供应商',open:false,value:'gys'},
        {name:'服务开始时间',open:false,value:'gmrq'},
        // {name:'使用部门',open:false,value:'sybm'},
        // {name:'维保周期',open:false,value:'wbzq'},
        // {name:'报废周期',open:false,value:'bfzq'}
    ])
    const jsjs = (row:any) => {
		requestZcSubjssj({
				id:row.cell.id
			}).then((res:any)=>{
				if(res.status === 1){
					row.cell.field0=res.datalist
				}
			})
	}
    const jsjs1 = (row:any) => {
		requestZcSubjssj1({
				id:row.cell.id
			}).then((res:any)=>{
				if(res.status === 1){
					row.cell.field1=res.datalist
				}
			})
	}
    const getStatus = computed(()=>{
		return function(status:number){
			let a = {
				1:"使用中",
				2:"损坏维修",
				3:"正在闲置",
				4:"已报废"
			}
			return a[status]
		}
	})
	const getType = computed(()=>{
		return function(status:number){
			let b = {
				1:"primary",
				2:"danger",
				3:"warning",
				4:"warning"
			}
			return b[status]
		}
	})
    onMounted(()=>{
		getMyUser();
        getList();
    })
	const getMyUser = () => {
		requestMyuser().then((res:any)=>{
			if(res.status === 1){
				userList.value = res.datalist[0]
			}
		})
	}
	// 选择导出列表
    const choosedcList = (item:any) => {
        item.open = !item.open
    }
	const dc = () => {
		let dcArr:any[] = []
        dcList.value.forEach((val:any)=>{
            if(val.open == true){
                dcArr.push(val.value)
            }
        })
        if(dcArr.length === 0){
            ElMessage({
                message: "请选择导出列",
                type: 'error',
                duration: 1500
            });
            return
        }
		requestDc({
            cols:dcArr.join(',')
        }).then((res:any)=>{
            if(res.status === 1){
			    ElMessage({
			        message: "导出成功",
			        type: 'success',
			        duration: 500
			    });
                dcLink.value = res.msg
                setTimeout(()=>{
                    nextTick(()=>{
						dcRef.value.click();
					})
                    dcShow.value = false
                },500)
			}else{
                ElMessage.error(res.msg);
            }
        })
		
	}
	const details = (row:any) => {
		id.value = row.cell.id
		show.value = true
	}
	const del = (row:any) => {
		requestZcglDel({
			id:row.cell.id
		}).then((res:any)=>{
			if(res.status === 1){
			    ElMessage({
			        message: "删除成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
                    searchList();
				},500)
			}
		})
	}
    //添加
    const add = () => {
		id.value = 0
        show.value = true
    }
    const searchList = () =>{
		pageIndex.value = 1
		getList();
	}
    const getList = () => {
        loading.value = true
		requestZcglList({
			pageIndex:pageIndex.value,
			pageSize:pageSize.value,
			name:search.value.name
		}).then((res:any)=>{
			
			tableData.value = res.data
			for(let i=0;i<tableData.value.length;i++){
				jsjs(tableData.value[i])
				jsjs1(tableData.value[i])
			}
			pages.value.totalCount = res.totalCount
			loading.value = false
			console.log(res.data);
		})
    }
    const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getList()
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getList()
	}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Select = _resolveComponent("Select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.name) = $event)),
              style: {width:'150px'},
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            type: "success",
            size: "small",
            icon: _unref(Download),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (dcShow.value=true))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_button, {
            plain: "",
            type: "primary",
            size: "small",
            icon: _unref(Search),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (searchList()))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["icon"]),
          (userList.value.rolelist=='管理员')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (add())),
                size: "small",
                icon: _unref(CirclePlus)
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["icon"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      border: "",
      "table-layout": "auto",
      data: tableData.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "80",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.lx",
          label: "资产类型",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.name",
          label: "资产名称",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.jdpp",
          label: "品牌",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.jdxh",
          label: "型号",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.xlh",
          label: "设备序列号",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.gmrq",
          label: "服务开始时间",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.dydw",
          label: "对应单位",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "维保内容",
          "class-name": "qp",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.nr=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(scope.row.cell.nr.split(','), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: _normalizeStyle({borderTop:index==0?'':'1px solid #ebeef5',padding: '0 12px'}),
                    key: index
                  }, _toDisplayString(item), 5))
                }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "维保时间",
          "class-name": "qp",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.sj=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(scope.row.cell.sj.split(','), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: _normalizeStyle({borderTop:index==0?'':'1px solid #ebeef5',padding: '0 12px'}),
                    key: index
                  }, _toDisplayString(item), 5))
                }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "到期时间",
          "class-name": "qp",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.field0=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(scope.row.cell.field0.split(','), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: _normalizeStyle({borderTop:index==0?'':'1px solid #ebeef5',padding: '0 12px'}),
                    key: index
                  }, _toDisplayString(item), 5))
                }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "剩余时间",
          "class-name": "qp",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.field1=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(scope.row.cell.field1.split(','), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: _normalizeStyle({borderTop:index==0?'':'1px solid #ebeef5',padding: '0 12px'}),
                    key: index
                  }, _toDisplayString(item) + "月 ", 5))
                }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "资产状态",
          width: "80"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: _unref(getType)(scope.row.cell.status)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getStatus)(scope.row.cell.status)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: _withModifiers(($event: any) => (details(scope.row)), ["stop"])
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (userList.value.rolelist=='管理员')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  link: "",
                  type: "danger",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (del(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      top: "5vh",
      modelValue: show.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((show).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        (show.value)
          ? (_openBlock(), _createBlock(AddZc, {
              key: 0,
              userList: userList.value,
              onSearchList: searchList,
              onAddshow: _cache[7] || (_cache[7] = ($event: any) => (show.value=false)),
              id: id.value
            }, null, 8, ["userList", "id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: dcShow.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dcShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dcList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flexAlign",
              style: {"width":"26%","margin-bottom":"20px"},
              key: index
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([item.open?'bor':'nobor', "flexCenter"]),
                onClick: ($event: any) => (choosedcList(item))
              }, [
                (item.open)
                  ? (_openBlock(), _createBlock(_component_el_icon, {
                      key: 0,
                      color: "#ffffff"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Select)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_23),
              _createElementVNode("div", _hoisted_24, _toDisplayString(item.name), 1)
            ]))
          }), 128)),
          _hoisted_25,
          _hoisted_26
        ]),
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (dcShow.value=false))
          }, {
            default: _withCtx(() => [
              _hoisted_29
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (dc()))
          }, {
            default: _withCtx(() => [
              _hoisted_30
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("a", {
      href: `${api.value}${dcLink.value}`,
      target: "_blank",
      ref_key: "dcRef",
      ref: dcRef
    }, null, 8, _hoisted_31)
  ]))
}
}

})